import { Else, If, Then } from '@hsp/react-component-library';

import { TableRow } from 'components/table/components/body/components';
import { Empty } from 'components/table/components/empty';
import { BodyProps } from 'types/components/table/components/body';

function Body<TData>({
  emptyMessage,
  onCollapsed,
  onExpanded,
  onRowSelected,
  renderSubComponent,
  table,
}: BodyProps<TData>) {
  const { getAllColumns, getRowModel } = table;
  const { rows } = getRowModel();

  return (
    <tbody>
      <If condition={rows.length > 0}>
        <Then>
          {rows.map((row) => (
            <TableRow
              key={row.id}
              onCollapsed={onCollapsed}
              onExpanded={(value) => {
                table.toggleAllRowsExpanded(false);
                onExpanded?.(value);
              }}
              onRowSelected={onRowSelected}
              renderSubComponent={renderSubComponent}
              row={row}
            />
          ))}
        </Then>
        <Else>
          {() => (
            <Empty
              columnSpan={getAllColumns().filter((column) => column.getIsVisible()).length}
              message={emptyMessage}
            />
          )}
        </Else>
      </If>
    </tbody>
  );
}

export default Body;
